/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainEntitiesDocumentsDocumentContent } from './FxIdDomainEntitiesDocumentsDocumentContent';
import {
    instanceOfFxIdDomainEntitiesDocumentsDocumentContent,
    FxIdDomainEntitiesDocumentsDocumentContentFromJSON,
    FxIdDomainEntitiesDocumentsDocumentContentFromJSONTyped,
    FxIdDomainEntitiesDocumentsDocumentContentToJSON,
} from './FxIdDomainEntitiesDocumentsDocumentContent';

/**
 * @type FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoContent
 * 
 * @export
 */
export type FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoContent = FxIdDomainEntitiesDocumentsDocumentContent;

export function FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoContentFromJSON(json: any): FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoContent {
    return FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoContentFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoContent {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainEntitiesDocumentsDocumentContent(json)) {
        return FxIdDomainEntitiesDocumentsDocumentContentFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoContentToJSON(json: any): any {
    return FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoContentToJSONTyped(json, false);
}

export function FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoContentToJSONTyped(value?: FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainEntitiesDocumentsDocumentContent(value)) {
        return FxIdDomainEntitiesDocumentsDocumentContentToJSON(value as FxIdDomainEntitiesDocumentsDocumentContent);
    }

    return {};
}

